module.exports = __webpack_public_path__ + "static/img/xstm.001.60970b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xstm.001.png
// module id = RSSx
// module chunks = 0